/* eslint-disable func-names */
import React from 'react';
import { Card } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import classes from './NotAddedAccount.module.scss';
import { isCountryChileOrPeru } from '@constants/regions';

export default function ({ hideDescription, noPadding }) {
  const { t } = useTranslation();
  const cardClasses = [classes.card];
  if (noPadding) cardClasses.push(classes.noPadding);

  if (isCountryChileOrPeru) {
    return <></>;
  } else {
    return (
      <Card className={cardClasses.join(' ')}>
        {!hideDescription && (
          <p className={classes.text}>{t('paymentsFoundsOut.common.contactOperationAddAccount')}</p>
        )}
      </Card>
    );
  }
}
